module.exports = ".summary-detail-title {\n  font-size: 20px; }\n"